module.exports = __webpack_public_path__ + "img/logo-header.5a889612.svg";